import { DirectiveOptions } from 'vue'
import * as stringUtils from '@ustra/core/src/utils/string-utils'

const getTargetEl = (el: HTMLElement) => {
  if ('input,textarea'.includes(el.tagName.toLowerCase())) {
    return el as HTMLElement
  }

  return el.querySelector('input,textarea') as HTMLElement
}

const byteLengthDirective: DirectiveOptions = {
  inserted: (el, binding) => {
    if (binding.value) {
      const input: HTMLElement = getTargetEl(el)

      if (input == null) {
        return
      }

      input.addEventListener('input', _e => {
        // @ts-ignore
        const value = _e.srcElement.value
        if (stringUtils.byteLength(value) > binding.value) {
          // @ts-ignore
          _e.srcElement.value = stringUtils.cutByteLength(value, binding.value)
        }
      })

      // input.addEventListener('paste', (_e) => {
      //   // @ts-ignore
      //   // const pasteData = (_e.clipboardData || window.clipboardData).getData('text')
      //   // if (pasteData) {
      //   //   _e.srcElement.value = stringUtils.cutByteLength(pasteData, binding.value)
      //   //   _e.preventDefault()
      //   // }
      // })
    }

    // console.log(el, binding)
  },
}
export { byteLengthDirective }
export default { byteLengthDirective }
